(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_afandi-hint-and-contact"] && !Shopify.designMode) return;
  try {
    (() => {

  if (customElements.get('afandi-hint')) return;


  const DRAFT_TTL =
    20 * 60 * 1000;


  const FIELDS = [
    'recipient_name',
    'recipient_email',
    'recipient_phone',
    'sender_name',
    'sender_email',
    'sender_phone',
    'note'
  ];


  class AfandiHint extends HTMLElement {


    connectedCallback() {

      if (this._connected) return;


      this._connected = true;


      this._abort =
        new AbortController();


      queueMicrotask(() => {

        if (this.isConnected) {

          this.setup();

        }

      });

    }


    disconnectedCallback() {

      this._abort?.abort();


      this._connected =
        false;

    }


    setup() {

      this.dialog =
        this.querySelector('dialog');


      if (!this.dialog) return;


      this.requestForm =
        this.querySelector('.ah-form');


      this.signupForm =
        this.querySelector('.ah-signup-form');


      this.key =
        `afandi-hint:${this.id}:${this.dataset.productId}`;


      this.designMode =
        Boolean(
          window.Shopify?.designMode
        );


      this.stage =
        'request';


      const on = (
        target,
        type,
        handler
      ) => {

        target?.addEventListener(
          type,
          handler,
          {
            signal:
              this._abort.signal
          }
        );

      };


      on(
        this.querySelector('[data-ah-open]'),
        'click',
        () => this.open()
      );


      this
        .querySelectorAll('[data-ah-close]')
        .forEach(button => {

          on(
            button,
            'click',
            () => this.dialog.close()
          );

        });


      on(
        this.dialog,
        'close',
        () => this.reset()
      );


      on(
        this.dialog,
        'pointerdown',
        event => {

          this._backdropDown =
            this.isOutside(event);

        }
      );


      on(
        this.dialog,
        'click',
        event => {

          if (
            this._backdropDown &&
            this.isOutside(event)
          ) {

            this.dialog.close();

          }


          this._backdropDown =
            false;

        }
      );


      on(
        this.requestForm,
        'input',
        event => {

          if (
            event.target.matches(
              '[data-ah-field]'
            )
          ) {

            event.target.setCustomValidity('');

          }

        }
      );


      on(
        this.querySelector(
          '[data-ah-submit-request]'
        ),
        'click',
        () => this.submitRequest()
      );


      on(
        this.querySelector(
          '[data-ah-submit-signup]'
        ),
        'click',
        () => this.submitSignup()
      );


      on(
        this.requestForm,
        'submit',
        event => {

          event.preventDefault();

          event.stopImmediatePropagation();

          this.submitRequest();

        }
      );


      on(
        this.signupForm,
        'submit',
        event => {

          event.preventDefault();

          event.stopImmediatePropagation();

          this.submitSignup();

        }
      );


      on(
        this.requestForm,
        'keydown',
        event => {

          if (
            event.key === 'Enter' &&
            event.target?.tagName !== 'TEXTAREA'
          ) {

            event.preventDefault();

            this.submitRequest();

          }

        }
      );


      on(
        this.signupForm,
        'keydown',
        event => {

          if (
            event.key === 'Enter'
          ) {

            event.preventDefault();

            this.submitSignup();

          }

        }
      );


      on(
        this.querySelector(
          '[data-ah-copy]'
        ),
        'click',
        () => this.copyMessage()
      );


      on(
        this.querySelector(
          '[data-ah-native-share]'
        ),
        'click',
        () => this.nativeShare()
      );


      on(
        this.querySelector(
          '[data-ah-email]'
        ),
        'click',
        () => {

          this.status(
            'Your email app should open. Review the message and press Send there.'
          );

        }
      );


      on(
        this.querySelector(
          '[data-ah-sms]'
        ),
        'click',
        () => {

          this.status(
            'Your messaging app should open. Review the message and press Send there.'
          );

        }
      );


      on(
        window,
        'pageshow',
        () => {

          this
            .querySelectorAll(
              '[data-ah-submit-request], [data-ah-submit-signup]'
            )
            .forEach(button => {

              button.disabled =
                false;

            });

        }
      );


      if (
        this.designMode &&
        this.dataset.previewPopup === 'true'
      ) {

        this.open();

      }

    }


    field(name) {

      return this.requestForm.querySelector(
        `[data-ah-field="${name}"]`
      );

    }


    value(name) {

      return (
        this.field(name)?.value ||
        ''
      ).trim();

    }


    setText(
      selector,
      text
    ) {

      const node =
        this.querySelector(selector);


      if (node) {

        node.textContent =
          text;

      }

    }


    status(text) {

      this.setText(
        '[data-ah-share-status]',
        text
      );

    }


    isOutside(event) {

      if (
        event.target !== this.dialog
      ) {

        return false;

      }


      const r =
        this.dialog.getBoundingClientRect();


      return (
        event.clientX < r.left ||
        event.clientX > r.right ||
        event.clientY < r.top ||
        event.clientY > r.bottom
      );

    }


    open() {

      if (!this.dialog.open) {

        this.dialog.showModal();

      }


      this
        .querySelector('.ah-title')
        .focus({
          preventScroll: true
        });

    }


    readDraft() {

      try {

        const value =
          JSON.parse(
            sessionStorage.getItem(
              this.key
            ) ||
            'null'
          );


        if (
          !value ||
          value.productId !==
            this.dataset.productId ||
          !Number.isFinite(
            value.created
          ) ||
          Date.now() -
            value.created >
            DRAFT_TTL
        ) {

          sessionStorage.removeItem(
            this.key
          );


          return null;

        }


        return value;

      } catch (_) {

        return null;

      }

    }


    writeDraft(value) {

      this.draft =
        value;


      try {

        sessionStorage.setItem(
          this.key,
          JSON.stringify(value)
        );


        return true;

      } catch (_) {

        return false;

      }

    }


    deleteDraft() {

      try {

        sessionStorage.removeItem(
          this.key
        );

      } catch (_) {}


      this.draft =
        null;

    }


    productData() {

      let variant =
        '';


      const scope =
        this.closest(
          '.shopify-section'
        ) ||
        this.parentElement;


      const forms =
        Array.from(
          scope?.querySelectorAll(
            'form[action*="/cart/add"]'
          ) ||
          []
        );


      const productForm =
        forms.find(form => {

          const productId =
            form.querySelector(
              '[name="product-id"]'
            )?.value;


          return (
            productId ===
            this.dataset.productId
          );

        });


      const formVariant =
        productForm?.querySelector(
          '[name="id"]'
        )?.value;


      const urlVariant =
        new URL(
          window.location.href
        )
          .searchParams
          .get('variant');


      if (
        /^\d+$/.test(
          formVariant ||
          ''
        )
      ) {

        variant =
          formVariant;

      }

      else if (
        /^\d+$/.test(
          urlVariant ||
          ''
        )
      ) {

        variant =
          urlVariant;

      }

      else {

        variant =
          this.dataset.initialVariant ||
          '';

      }


      const url =
        new URL(
          this.dataset.productUrl,
          window.location.origin
        );


      if (
        /^\d+$/.test(
          variant
        )
      ) {

        url.searchParams.set(
          'variant',
          variant
        );

      }


      return {

        variant,

        productUrl:
          url.href

      };

    }


    collectDraft() {

      const fields =
        Object.fromEntries(
          FIELDS.map(name => [
            name,
            this.value(name)
          ])
        );


      return {

        fields,

        ...this.productData(),

        productId:
          this.dataset.productId,

        created:
          Date.now(),

        pending:
          'contact',

        requestResult:
          '',

        requestId:
          window.crypto?.randomUUID?.() ||
          `AH-${Date.now()}-${Math.random()
            .toString(36)
            .slice(2, 10)}`

      };

    }


    validatePhones() {

      let valid =
        true;


      [
        'sender_phone',
        'recipient_phone'
      ].forEach(name => {

        const field =
          this.field(name);


        if (!field) return;


        const value =
          field.value.trim();


        const digits =
          value.replace(
            /\D/g,
            ''
          );


        const ok =
          !value ||
          (
            /^[+\d().\s-]+$/.test(
              value
            ) &&
            digits.length >= 7 &&
            digits.length <= 15
          );


        field.setCustomValidity(
          ok
            ? ''
            : 'Enter a phone number with 7–15 digits, using numbers, spaces, +, ( ), or - only.'
        );


        if (!ok) {

          valid =
            false;

        }

      });


      return valid;

    }


    async submitRequest() {

      this.validatePhones();


      if (
        !this.requestForm.reportValidity()
      ) {

        return;

      }


      const draft =
        this.collectDraft();


      this.requestForm.querySelector(
        '[data-ah-product-link]'
      ).value =
        draft.productUrl;


      this.requestForm.querySelector(
        '[data-ah-variant]'
      ).value =
        draft.variant;


      this.requestForm.querySelector(
        '[data-ah-request-id]'
      ).value =
        draft.requestId;


      draft.pending =
        '';


      draft.requestResult =
        'submitted';


      this.writeDraft(
        draft
      );


      const submitButton =
        this.querySelector(
          '[data-ah-submit-request]'
        );


      if (
        submitButton?.disabled
      ) {

        return;

      }


      if (submitButton) {

        submitButton.disabled =
          true;

      }


      this.showShare(
        draft
      );


      try {

        await fetch(
          this.requestForm.action,
          {

            method:
              'POST',

            body:
              new FormData(
                this.requestForm
              ),

            credentials:
              'same-origin',

            redirect:
              'manual'

          }
        );

      }

      catch (_) {}


      finally {

        if (submitButton) {

          submitButton.disabled =
            false;

        }

      }

    }


    async submitSignup() {

      if (!this.signupForm) return;


      const consent =
        this.signupForm.querySelector(
          '[data-ah-consent]'
        );


      if (
        !consent?.checked ||
        !this.signupForm.reportValidity()
      ) {

        return;

      }


      const submitButton =
        this.querySelector(
          '[data-ah-submit-signup]'
        );


      if (
        submitButton?.disabled
      ) {

        return;

      }


      if (submitButton) {

        submitButton.disabled =
          true;

      }


      const draft =
        this.draft ||
        this.readDraft() ||
        this.collectDraft();


      draft.pending =
        '';


      draft.created =
        Date.now();


      draft.signupEmail =
        this.signupForm
          .querySelector(
            '[data-ah-signup-email]'
          )
          .value
          .trim();


      this.writeDraft(
        draft
      );


      this.setText(
        '[data-ah-signup-status]',
        'Thanks! Your signup request has been received.'
      );


      try {

        await fetch(
          this.signupForm.action,
          {

            method:
              'POST',

            body:
              new FormData(
                this.signupForm
              ),

            credentials:
              'same-origin',

            redirect:
              'manual'

          }
        );

      }

      catch (_) {

        this.setText(
          '[data-ah-signup-status]',
          'Thanks! Your request was received. If you are already subscribed, no further action is needed.'
        );

      }

      finally {

        if (submitButton) {

          submitButton.disabled =
            false;

        }

      }

    }


    cleanReturnURL() {

      try {

        const url =
          new URL(
            window.location.href
          );


        [
          'contact_posted',
          'customer_posted',
          'form_type',
          'utf8'
        ].forEach(key =>

          url.searchParams.delete(
            key
          )

        );


        if (
          url.hash ===
            `#${this.id}` ||
          url.hash ===
            `#${this.requestForm.id}` ||
          url.hash ===
            `#${this.signupForm?.id}`
        ) {

          url.hash =
            '';

        }


        history.replaceState(
          history.state,
          '',
          url.pathname +
            url.search +
            url.hash
        );

      }

      catch (_) {}

    }


    fillTemplate(
      template,
      tokens
    ) {

      return String(
        template
      ).replace(
        /\{(recipient|sender|product|shop|note|url)\}/g,
        (_, name) =>
          tokens[name] ||
          ''
      );

    }


    buildMessage(draft) {

      const fields =
        draft.fields ||
        {};


      const tokens = {

        recipient:
          fields.recipient_name ||
          'there',

        sender:
          fields.sender_name ||
          '',

        product:
          this.dataset.productTitle ||
          '',

        shop:
          this.dataset.shopName ||
          '',

        note:
          fields.note ||
          '',

        url:
          draft.productUrl ||
          this.dataset.productUrl ||
          ''

      };


      const subjectTemplate =
        this.dataset.subject ||
        'A little hint from {sender}';


      let message =
        this
          .fillTemplate(
            this.dataset.template,
            tokens
          )
          .replace(
            /\n{3,}/g,
            '\n\n'
          )
          .trim();


      if (
        tokens.url &&
        !message.includes(
          tokens.url
        )
      ) {

        message +=
          `\n\n${tokens.url}`;

      }


      const subject =
        this
          .fillTemplate(
            subjectTemplate,
            tokens
          )
          .replace(
            /[\r\n]/g,
            ' '
          )
          .trim();


      return {

        subject,

        message

      };

    }


    showShare(draft) {

      this.draft =
        draft;


      this.stage =
        'share';


      this.querySelector(
        '[data-ah-step="request"]'
      ).hidden =
        true;


      this.querySelector(
        '[data-ah-step="share"]'
      ).hidden =
        false;


      this.setText(
        '[data-ah-request-status]',
        'Your hint is ready!'
      );


      const {
        subject,
        message
      } =
        this.buildMessage(
          draft
        );


      this.message =
        message;


      this.subject =
        subject;


      const address =
        (
          draft.fields
            ?.recipient_email ||
          ''
        )
          .replace(
            /[\r\n]/g,
            ''
          )
          .trim();


      this.querySelector(
        '[data-ah-email]'
      ).href =
        `mailto:${encodeURIComponent(address)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;


      const sms =
        this.querySelector(
          '[data-ah-sms]'
        );


      if (sms) {

        const raw =
          (
            draft.fields
              ?.recipient_phone ||
            ''
          ).trim();


        const phone =
          (
            raw.startsWith('+')
              ? '+'
              : ''
          ) +
          raw.replace(
            /\D/g,
            ''
          );


        const iOS =
          /iPad|iPhone|iPod/.test(
            navigator.userAgent
          ) ||
          (
            navigator.platform ===
              'MacIntel' &&
            navigator.maxTouchPoints >
              1
          );


        sms.href =
          `sms:${phone}${iOS ? '&' : '?'}body=${encodeURIComponent(message)}`;

      }


      const nativeButton =
        this.querySelector(
          '[data-ah-native-share]'
        );


      nativeButton.hidden =
        typeof navigator.share !==
        'function';


      const signupEmail =
        this.querySelector(
          '[data-ah-signup-email]'
        );


      if (signupEmail) {

        signupEmail.value =
          draft.signupEmail ||
          draft.fields
            ?.sender_email ||
          '';

      }


      this.querySelector(
        '[data-ah-message]'
      ).value =
        message;


      this.querySelector(
        '[data-ah-email]'
      ).focus({
        preventScroll:
          true
      });

    }


    async copyMessage() {

      try {

        if (
          !navigator.clipboard
            ?.writeText
        ) {

          throw new Error(
            'Clipboard unavailable'
          );

        }


        await navigator.clipboard.writeText(
          this.message ||
          ''
        );


        this.status(
          'Message copied!'
        );

      }

      catch (_) {

        const box =
          this.querySelector(
            '[data-ah-manual-copy]'
          );


        const textarea =
          this.querySelector(
            '[data-ah-message]'
          );


        box.hidden =
          false;


        textarea.focus();


        textarea.select();


        this.status(
          'Select and copy the prepared message below.'
        );

      }

    }


    async nativeShare() {

      try {

        await navigator.share({

          title:
            this.subject,

          text:
            this.message

        });


        this.status(
          'Sharing app closed. Check that app to confirm whether the message was sent.'
        );

      }

      catch (error) {

        if (
          error?.name !==
          'AbortError'
        ) {

          this.status(
            'Sharing is unavailable here. Use email, text, or Copy message instead.'
          );

        }

      }

    }


    reset() {

      this.deleteDraft();


      this.cleanReturnURL();


      this.stage =
        'request';


      this.requestForm?.reset();


      this.signupForm?.reset();


      this.querySelector(
        '[data-ah-step="request"]'
      ).hidden =
        false;


      this.querySelector(
        '[data-ah-step="share"]'
      ).hidden =
        true;


      this.querySelector(
        '[data-ah-manual-copy]'
      ).hidden =
        true;


      this.querySelector(
        '[data-ah-client-error]'
      ).hidden =
        true;


      this.status('');


      this.setText(
        '[data-ah-signup-status]',
        ''
      );


      this
        .querySelectorAll(
          '[data-ah-server-errors], [data-ah-signup-errors]'
        )
        .forEach(node => {

          node.hidden =
            true;

        });


      FIELDS.forEach(name => {

        this
          .field(name)
          ?.setCustomValidity('');

      });

    }

  }


  customElements.define(
    'afandi-hint',
    AfandiHint
  );

})();
  } catch(e) { console.error(e); }
})();

})();
